import { field, formatEther, readContract, writeContractAndWait } from "../viem";

import MafiaTrainingAbi from "../../abis/MafiaTraining.json";
import config from "../../config/config";
import { TrainingSlotType } from "../../types/TrainingSlotType";

const address = config.training;
const abi = MafiaTrainingAbi;

export const getTrainingSlots = async (
  account: string
): Promise<TrainingSlotType[]> => {
  const trainingSlots: any[] = await readContract({
    address,
    abi,
    functionName: "getTrainingSlots",
    args: [account],
  });

  return trainingSlots.map((slot: any) => ({
    endTime: Number(field(slot, "endTime", 5)),
    isTraining: field(slot, "isTraining", 7),
    newCategoryId: Number(field(slot, "newCategoryId", 2)),
    newTypeId: Number(field(slot, "newTypeId", 3)),
    oldItemId: Number(field(slot, "oldItemId", 0)),
    startTime: Number(field(slot, "startTime", 4)),
    trainingCost: Number(formatEther(field(slot, "trainingCost", 6))),
  }));
};

export const getTrainingCost = async (
  categoryId: number,
  typeId: number
): Promise<number> => {
  const cost: bigint = await readContract({
    address,
    abi,
    functionName: "getTrainingCost",
    args: [categoryId, typeId],
  });

  return Number(formatEther(cost));
};

export const trainBodyguard = async (
  account: string,
  slotId: number,
  itemId: number
) => {
  const result = await writeContractAndWait({
    address,
    abi,
    functionName: "trainBodyguard",
    args: [slotId, itemId],
    account,
  });

  return result;
};

export const finishTraining = async (account: string, slotId: number) => {
  const result = await writeContractAndWait({
    address,
    abi,
    functionName: "finishTraining",
    args: [slotId],
    account,
  });

  return result;
};
